module.exports = __webpack_public_path__ + "img/xyd_03.0cba6874.png";